import { Box, Tooltip, Typography, makeStyles } from '@material-ui/core';
import { BAR_COLOR } from './palette';

const useStyles = makeStyles(theme => ({
    row: {
        '& + &': {
            marginTop: theme.spacing(1.5)
        }
    },
    track: {
        height: 8,
        borderRadius: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        overflow: 'hidden'
    },
    // the same list read from across a room rather than at a desk - but a slide
    // holds one of these above a board, so it is only as tall as it has to be
    largeRow: {
        '& + &': {
            marginTop: theme.spacing(1.5)
        }
    },
    largeTrack: {
        height: 10,
        borderRadius: 5
    },
    largeText: {
        fontSize: '1.15rem'
    },
    bar: {
        height: '100%',
        borderRadius: 4,
        minWidth: 0
    },
    label: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
}));

// A list of labelled bars, the length of each one read against the largest value
// of the list. The label and the value are always written out, so the bars stay
// readable without their colours. `large` sets it up for the slideshow, where it
// is read from further away than a dashboard is.
function BarList(props) {
    const classes = useStyles();
    const items = props.items ?? [];
    if (items.length === 0) {
        return <Typography color='textSecondary'> {props.emptyMessage ?? "No data"} </Typography>;
    }
    const large = props.large === true;
    const text = large ? classes.largeText : '';
    const max = Math.max(...items.map(item => item.value), 0);
    return (
        <Box>
            {items.map(item => (
                <Tooltip key={item.key} title={item.tooltip ?? ''} placement='top' arrow>
                    <Box className={`${classes.row} ${large ? classes.largeRow : ''}`}>
                        <Box display='flex' alignItems='baseline' style={{ gap: 8 }} mb={0.5}>
                            <Typography variant='body2' className={`${classes.label} ${text}`}> {item.label} </Typography>
                            <Box flexGrow={1} />
                            <Typography variant='body2' color='textSecondary' className={text} noWrap> {item.valueLabel} </Typography>
                            {item.note && <Typography variant='caption' color='textSecondary' noWrap> {item.note} </Typography>}
                        </Box>
                        <div className={`${classes.track} ${large ? classes.largeTrack : ''}`}>
                            <div
                                className={classes.bar}
                                style={{
                                    width: `${max === 0 ? 0 : item.value / max * 100}%`,
                                    backgroundColor: item.color ?? BAR_COLOR
                                }}
                            />
                        </div>
                    </Box>
                </Tooltip>
            ))}
        </Box>
    );
}

export default BarList;
